<template>
  <!-- Facturación, cobros e hitos: derivado de la tabla de Facturación del Resumen (S03). -->
  <summary-card :title="$t('prm_dash_billing_title')" :mode="mode" chip="fact">
    <template #icon><b-icon pack="fas" icon="file-invoice-dollar" size="is-small"></b-icon></template>

    <table class="kv">
      <tbody>
        <tr><td class="k">{{ $t('prm_dash_billing_total_sale') }}</td><td class="v"><b>{{ eur(billing.totalSale) }}</b></td></tr>
        <tr><td class="k">{{ $t('prm_dash_billing_invoiced') }}</td><td class="v"><b>{{ eur(billing.invoiced) }}</b></td></tr>
        <tr><td class="k">{{ $t('prm_dash_billing_collected') }}</td><td class="v"><b>{{ eur(billing.collected) }}</b></td></tr>
        <tr><td class="k">{{ $t('prm_dash_billing_pending_invoice') }}</td><td class="v"><b>{{ eur(billing.pendingToInvoice) }}</b></td></tr>
        <tr><td class="k">{{ $t('prm_dash_billing_pending_collect') }}</td><td class="v"><b>{{ eur(billing.pendingToCollect) }}</b></td></tr>
        <tr>
          <td class="k">{{ $t('prm_dash_billing_overdue') }}</td>
          <td class="v"><b :style="{ color: billing.overdue > 0 ? '#c0392b' : '#1e8449' }">{{ eur(billing.overdue) }}</b></td>
        </tr>
        <tr>
          <td class="k">{{ $t('prm_dash_billing_next_milestone') }}</td>
          <td class="v next">{{ nextText }}</td>
        </tr>
      </tbody>
    </table>

    <div class="foot">
      <span>{{ $t('prm_dash_billing_status') }}</span>
      <sem-dot :state="billing.status || 'green'"></sem-dot>
    </div>
  </summary-card>
</template>

<script>
  import SummaryCard from '../summary/summary-card.vue'
  import SemDot from './sem-dot.vue'
  import { fmtEur, fmtDate } from '../shared/format'

  export default {
    name: 'PrmDashBilling',

    components: { SummaryCard, SemDot },

    props: {
      billing: { type: Object, default: () => ({}) },
      mode: { type: Boolean, default: false },
    },

    computed: {
      nextText () {
        const m = this.billing.nextMilestone
        if (!m) return '-'
        const date = m.estimatedDate ? ` · ${fmtDate(m.estimatedDate)}` : ''
        return `${m.description || '-'}${date}`
      },
    },

    methods: {
      eur (v) { return fmtEur(v || 0) },
    },
  }
</script>

<style lang="scss" scoped>
  .kv { width: 100%; border-collapse: collapse; }
  .kv td { border-bottom: 1px solid #eef0f3; padding: 6px 10px; font-size: 11px; vertical-align: middle; }
  .kv tbody tr:nth-child(even) td { background: #f9fafb; }
  .kv tbody tr:hover td { background: #eef2f7; }
  .k { color: #3d5570; }
  .v { text-align: right; white-space: nowrap; }
  .v b { font-weight: 700; font-variant-numeric: tabular-nums; }
  .v.next { text-align: right; color: #2c3a4d; font-size: 10px; white-space: normal; }

  .foot {
    display: flex; align-items: center; justify-content: space-between; gap: 8px;
    padding: 8px 10px; background: #eef3f9; font-size: 11px; font-weight: 600; color: #1e3046;
  }
</style>
